import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/drawingSchedulesReportActions'
import * as api from '../../../api/reports/jobs/drawingSchedulesReport'

function* drawingSchedulesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* drawingSchedulesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchdrawingSchedulesReportGetJobList() {
  yield takeLatest(
    constants.DRAWING_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    drawingSchedulesReportGetJobList
  )
}

function* watchdrawingSchedulesReportGetFullReport() {
  yield takeLatest(
    constants.DRAWING_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    drawingSchedulesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchdrawingSchedulesReportGetJobList),
    fork(watchdrawingSchedulesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/drawingSchedulesReportSaga.js